import JILI from "assets/images/game/table-card/table-card_JILI.png";
import { SubGameType } from "types/game";

export const listGameTableCard: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "JILI",
    type: "BG",
    featured: "NO",
    new_arrive: "NO",
    picture: JILI,
  },
];
